import React, { useState, useEffect, useRef, useContext } from "react";

import axios from "axios";
import { Formik, Form, Field, useFormikContext } from "formik";
import { toast } from "react-toastify";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";



import moment from "moment";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Paper,
  Box,
  Typography
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

import TabPanel from "../TabPanel";
import { Autorenew, FileCopy } from "@material-ui/icons";

import ContactsTheme from "../../pages/Contacts/theme";
import { Close, LinkOutlined } from "@material-ui/icons";
import useStyles from "./styles";
import { sessionSchema, fieldTab, checkSettings, createToken } from "./form";

import { AuthContext } from "../../context/Auth/AuthContext";

function ValidationFocus({ setTab }) {
 const { errors, submitCount, isSubmitting, isValidating } = useFormikContext();
 const seen = useRef(0);
 useEffect(() => {
  if (!submitCount || seen.current === submitCount || isSubmitting || isValidating || !Object.keys(errors).length) return;
  seen.current = submitCount; const field = Object.keys(errors)[0]; setTab(fieldTab(field));
  const timer = setTimeout(() => { const input = document.querySelector('#whatsapp-form [name="' + field + '"]'); if (input) input.focus(); }, 0);
  return () => clearTimeout(timer);
 }, [errors, submitCount, isSubmitting, isValidating, setTab]);
 return null;
}
const WhatsAppEditor = ({ open, onClose, whatsAppId, onSaved, adminMode = false }) => {
  const connectionBase = adminMode ? "/whatsapp-admin" : "/whatsapp";
  const classes = useStyles();
  const [autoToken, setAutoToken] = useState("");
  const [loading, setLoading] = useState(true), [loadError, setLoadError] = useState(false), [revision, setRevision] = useState(0);
  const [saveError, setSaveError] = useState("");
  const persistedId = useRef(whatsAppId || null), saving = useRef(false), mediaWasPresent = useRef(false);
  const [tokenBusy, setTokenBusy] = useState(false), [confirmToken, setConfirmToken] = useState(false);
  const tokenLock = useRef(false);

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null)
  const [attachmentName, setAttachmentName] = useState('')

  const initialState = {
    name: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    autoReply: "enabled",
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: '0',
    timeSendQueue: '0',
    sendIdQueue: 0,
    expiresTicketNPS: '0',
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    integrationId: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    queueIdImportMessages: null
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] = useState(false);
  const [importOldMessages, setImportOldMessages] = useState(moment().add(-1, "days").format("YYYY-MM-DDTHH:mm"));
  const [importRecentMessages, setImportRecentMessages] = useState(moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm"));
  const [copied, setCopied] = useState(false);

  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { user } = useContext(AuthContext);
  const [targetCompany, setTargetCompany] = useState(null);
  const originalLinks = useRef({});



  const [schedules, setSchedules] = useState([
    { weekday: i18n.t("queueModal.serviceHours.monday"), weekdayEn: "monday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: i18n.t("queueModal.serviceHours.tuesday"), weekdayEn: "tuesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: i18n.t("queueModal.serviceHours.wednesday"), weekdayEn: "wednesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: i18n.t("queueModal.serviceHours.thursday"), weekdayEn: "thursday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: i18n.t("queueModal.serviceHours.friday"), weekdayEn: "friday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: "Sábado", weekdayEn: "saturday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
    { weekday: "Domingo", weekdayEn: "sunday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00", },
  ]);




  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [prompts, setPrompts] = useState([]);
  const [promptsLoading, setPromptsLoading] = useState(false);
  const [promptsError, setPromptsError] = useState(false);
  const [promptsRevision, setPromptsRevision] = useState(0);

  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();

  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [integrations, setIntegrations] = useState([]);
  const [integrationsLoading, setIntegrationsLoading] = useState(false);
  const [integrationsError, setIntegrationsError] = useState(false);
  const [integrationsRevision, setIntegrationsRevision] = useState(0);

  useEffect(() => {
    let active = true; const cancel = axios.CancelToken.source();
    const config = { timeout: 20000, cancelToken: cancel.token };
    setLoading(true); setLoadError(false);
    const request = adminMode ? Promise.all([
      api.get(connectionBase + "/" + whatsAppId + "?session=0", config),
      api.get(connectionBase + "/" + whatsAppId + "/context", config)
    ]).then(([session, { data: context }]) => [session, { data: context.company }, { data: { scheduleType: context.settings.scheduleType } }, { data: { userRating: context.settings.userRating } }, { data: context.queues }, context]) : Promise.all([
      whatsAppId ? api.get(connectionBase + "/" + whatsAppId + "?session=0", config) : Promise.resolve({ data: initialState }),
      api.get("/companies/listPlan/" + user.companyId, config),
      api.get("/companySettingOne", { ...config, params: { column: "scheduleType" } }),
      api.get("/companySettingOne", { ...config, params: { column: "userRating" } }), api.get("/queue", config)
    ]);
    request.then(async ([session, company, hours, nps, queueResult, context]) => {
      const flows = adminMode ? { data: { flows: context.flows } } : company.data.plan?.useIntegrations ? await api.get("/flowbuilder", { ...config, params: { summary: true } }) : { data: { flows: [] } };
      if (!active) return;
      const data = session.data;
      if (adminMode && String(data.companyId) !== String(company.data.id)) throw new Error("Connection company mismatch");
      setTargetCompany(company.data);
      originalLinks.current = { promptId: data.promptId, integrationId: data.integrationId, flowIdWelcome: data.flowIdWelcome, flowIdNotPhrase: data.flowIdNotPhrase };
      if (adminMode) { setPrompts(context.prompts || []); setIntegrations(context.integrations || []); }
      const normalized = { ...initialState, ...data };
      Object.keys(initialState).forEach(key => { if (normalized[key] === null) normalized[key] = initialState[key]; });
      ["collectiveVacationStart", "collectiveVacationEnd"].forEach(key => { normalized[key] = normalized[key] ? String(normalized[key]).slice(0, 10) : ""; });
      setWhatsApp(normalized);
      setShowOpenAi(Boolean(company.data.plan?.useOpenAi)); setShowIntegrations(Boolean(company.data.plan?.useIntegrations));
      setSchedulesEnabled(hours.data.scheduleType === "connection"); setNPSEnabled(nps.data.userRating === "enabled");
      setQueues(queueResult.data || []); setWebhooks(flows.data.flows || []);
      setFlowIdNotPhrase(data.flowIdNotPhrase || ""); setFlowIdWelcome(data.flowIdWelcome || "");
      setSelectedIntegration(data.integrationId || ""); setSelectedPrompt(data.promptId || "");
      setSelectedQueueIds((data.queues || []).map(queue => queue.id));
      setAttachmentName(data.greetingMediaAttachment || ""); mediaWasPresent.current = Boolean(data.greetingMediaAttachment);
      setAutoToken(data.token || (whatsAppId ? "" : createToken()));
      if (Array.isArray(data.schedules) && data.schedules.length) setSchedules(data.schedules);
      if (data.importOldMessages) {
        setEnableImportMessage(true); setImportOldMessages(data.importOldMessages); setImportRecentMessages(data.importRecentMessages);
        setImportOldMessagesGroups(Boolean(data.importOldMessagesGroups)); setClosedTicketsPostImported(Boolean(data.closedTicketsPostImported));
      }
      setLoading(false);
    }).catch(err => { if (active && !axios.isCancel(err)) { setLoadError(true); setLoading(false); } });
    return () => { active = false; cancel.cancel(); };
    // initialState is fixed for each mounted editor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whatsAppId, user.companyId, revision, adminMode, connectionBase]);

  useEffect(() => {
    if (!open || !showOpenAi || adminMode) return undefined;
    let active = true;
    const cancel = axios.CancelToken.source();
    setPromptsLoading(true); setPromptsError(false);
    api.get("/prompt/options", { timeout: 20000, cancelToken: cancel.token })
      .then(({ data }) => { if (active) setPrompts(data.prompts); })
      .catch(err => { if (active && !axios.isCancel(err)) setPromptsError(true); })
      .finally(() => { if (active) setPromptsLoading(false); });
    return () => { active = false; cancel.cancel(); };
  }, [open, showOpenAi, whatsAppId, user.companyId, promptsRevision, adminMode]);

  const handleEnableImportMessage = e => setEnableImportMessage(e.target.checked);

  useEffect(() => {
    if (!open || !showIntegrations || adminMode) return undefined;
    let active = true;
    const cancel = axios.CancelToken.source();
    setIntegrationsLoading(true); setIntegrationsError(false);
    api.get("/queueIntegration/options", { timeout: 20000, cancelToken: cancel.token })
      .then(({ data }) => { if (active) setIntegrations(Array.isArray(data.queueIntegrations) ? data.queueIntegrations : []); })
      .catch(err => { if (active && !axios.isCancel(err)) setIntegrationsError(true); })
      .finally(() => { if (active) setIntegrationsLoading(false); });
    return () => { active = false; cancel.cancel(); };
  }, [open, showIntegrations, whatsAppId, user.companyId, integrationsRevision, adminMode]);


  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
    setSelectedPrompt(null);
    setSelectedIntegration(null)
  };

  const handleChangeIntegration = (e) => {
    setSelectedIntegration(e.target.value)
    setSelectedPrompt(null)
    setSelectedQueueIds([])
  }

  const handleChangeFlowIdNotPhrase = (e) => {
    setFlowIdNotPhrase(e.target.value)
  }

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value)
  }


  const handleChangePrompt = (e) => {
    setSelectedPrompt(e.target.value);
    setSelectedQueueIds([]);
    setSelectedIntegration(null);
  };

  const handleSaveWhatsApp = async (values, actions) => {
    if (saving.current || tokenLock.current) { actions.setSubmitting(false); return; }
    const validation = checkSettings(values, { nps: NPSEnabled, importing: enableImportMessage, from: importOldMessages, to: importRecentMessages, schedulesEnabled, schedules });
    if (validation) { setTab(validation[0]); setSaveError(validation[1]); actions.setSubmitting(false); return; }
    saving.current = true; setSaveError("");
    const whatsappData = {};
    Object.keys(initialState).forEach(key => { if (values[key] !== undefined) whatsappData[key] = values[key]; });
    ["maxUseBotQueues", "expiresTicket", "timeUseBotQueues", "timeSendQueue", "expiresTicketNPS", "timeInactiveMessage", "maxUseBotQueuesNPS", "timeCreateNewTicket"].forEach(key => { whatsappData[key] = Number(values[key] || 0); });
    Object.assign(whatsappData, {
      name: values.name.trim(), flowIdWelcome: flowIdWelcome || null, flowIdNotPhrase: flowIdNotPhrase || null,
      integrationId: selectedIntegration || null, promptId: selectedPrompt || null, queueIds: selectedQueueIds,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: enableImportMessage && importOldMessagesGroups,
      closedTicketsPostImported: enableImportMessage && closedTicketsPostImported,
      token: autoToken || null, ...(schedulesEnabled ? { schedules } : {})
    });
    delete whatsappData.greetingMediaAttachment;
    // A disabled plan feature keeps its existing link when this form did not change it.
    const preserve = (key, enabled) => { if (!enabled && String(whatsappData[key] || "") === String(originalLinks.current[key] || "")) delete whatsappData[key]; };
    preserve("promptId", showOpenAi); ["integrationId", "flowIdWelcome", "flowIdNotPhrase"].forEach(key => preserve(key, showIntegrations));
    let configurationSaved = false;
    try {
      if (persistedId.current) await api.put(connectionBase + "/" + persistedId.current, whatsappData, { timeout: 20000 });
      else {
        const { data } = await api.post("/whatsapp", whatsappData, { timeout: 20000 });
        persistedId.current = data.id;
      }
      configurationSaved = true;
      if (attachment) {
        const formData = new FormData(); formData.append("file", attachment);
        await api.post(connectionBase + "/" + persistedId.current + "/media-upload", formData, { timeout: 60000 });
        setAttachment(null); mediaWasPresent.current = true;
      } else if (!attachmentName && mediaWasPresent.current) {
        await api.delete(connectionBase + "/" + persistedId.current + "/media-upload", { timeout: 20000 }); mediaWasPresent.current = false;
      }
      if (onSaved) onSaved();
      toast.success("Conexão salva com sucesso."); onClose();
    } catch (err) {
      setSaveError(configurationSaved && attachment ? "Conexão salva, mas o arquivo não foi enviado. Tente salvar novamente." : "Não foi possível salvar. Seus dados foram mantidos para tentar novamente.");
      toastError(err);
    } finally { saving.current = false; actions.setSubmitting(false); }
  };

  const handleRefreshToken = async () => {
    if (saving.current || tokenLock.current) return;
    if (persistedId.current && !confirmToken) { setConfirmToken(true); return; }
    tokenLock.current = true; setTokenBusy(true); setConfirmToken(false);
    try {
      if (persistedId.current) {
        const { data } = await api.post(connectionBase + "/" + persistedId.current + "/token", undefined, { timeout: 20000 });
        setAutoToken(data.token); toast.success("Novo token gerado e salvo.");
      } else setAutoToken(createToken());
      setCopied(false);
    } catch (err) { toastError(err); }
    finally { tokenLock.current = false; setTokenBusy(false); }
  };
  const handleCopyToken = async () => {
    try { await navigator.clipboard.writeText(autoToken); setCopied(true); }
    catch (_) { setCopied(false); setSaveError("Não foi possível copiar o token. Verifique a permissão da área de transferência."); }
  };
  const handleClose = () => { if (!saving.current && !tokenLock.current) onClose(); };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) { setSaveError("A imagem ou o vídeo deve ter até 20 MB."); inputFileRef.current.value = null; return; }
    setSaveError("");
    setAttachment(file)
    setAttachmentName(file.name)
    inputFileRef.current.value = null
  };

  const handleDeleFile = () => {
    setAttachment(null)
    setAttachmentName(null)
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        classes={{ paper: classes.dialog }}
        aria-labelledby="whatsapp-editor-title"
        fullWidth
        scroll="paper"
      >
        <DialogTitle disableTypography className={classes.title}><LinkOutlined /><Typography component="h2" id="whatsapp-editor-title">{whatsAppId ? "Editar conexão" : "Nova conexão"}{adminMode && targetCompany && <Typography component="span" className={classes.hint} style={{ display: "block", margin: "4px 0 0" }}>{targetCompany.name} · Empresa #{targetCompany.id}</Typography>}</Typography><IconButton aria-label="Fechar formulário" onClick={handleClose}><Close /></IconButton></DialogTitle>
        {loading || loadError ? <div className={classes.loading}>{loadError ? <><Typography role="alert">Não foi possível carregar o formulário.</Typography><Button onClick={() => setRevision(v => v + 1)}>Tentar novamente</Button><Button onClick={handleClose}>Cancelar</Button></> : <><CircularProgress size={28} /><Typography>Carregando conexão…</Typography></>}</div> :
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={sessionSchema}
          onSubmit={handleSaveWhatsApp}
        >
          {({ values, touched, errors, isSubmitting, submitCount }) => (
            <Form id="whatsapp-form" noValidate className={classes.form}>
              <ValidationFocus setTab={setTab} />
              {submitCount > 0 && Object.keys(errors).length > 0 && <div role="alert" className={classes.error}>Revise os campos destacados. </div>}
              {saveError && <div role="alert" className={classes.error}>{saveError}</div>}
              <Paper className={classes.mainPaper} elevation={1}>
                <Tabs
                  value={tab}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="on"
                  variant="scrollable"
                  onChange={handleTabChange}
                  className={classes.tab}
                >
                  <Tab label={i18n.t("whatsappModal.tabs.general")} value={"general"} />
                  <Tab label={i18n.t("whatsappModal.tabs.integrations")} value={"integrations"} />
                  <Tab label={i18n.t("whatsappModal.tabs.messages")} value={"messages"} />
                  <Tab label="Chatbot" value={"chatbot"} />
                  <Tab label={i18n.t("whatsappModal.tabs.assessments")} value={"nps"} />
                  {showIntegrations && <Tab label="Fluxos" value={"flowbuilder"} />}
                  {schedulesEnabled && <Tab label={i18n.t("whatsappModal.tabs.schedules")} value={"schedules"} />}
                </Tabs>
              </Paper>
              <Paper className={classes.paper} elevation={0}><fieldset disabled={isSubmitting || tokenBusy} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"general"}
                >
                  <DialogContent dividers>
                    {/* NOME E PADRAO */}
                    <div className={classes.multFieldLine}>
                      <Grid spacing={2} container>
                        <Grid item xs={12} md={6}>
                          <Field
                            as={TextField}
                            disabled={isSubmitting || tokenBusy}
                            label={i18n.t("whatsappModal.form.name")}
                            autoFocus
                            id="connection-name"
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            variant="outlined"
                            margin="dense"
                            className={classes.textField}
                          />
                        </Grid>
                        <Grid style={{ paddingTop: 15 }} item>
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                            disabled={isSubmitting || tokenBusy}
                                color="primary"
                                id="connection-isDefault"
                            name="isDefault"
                                checked={values.isDefault}
                              />
                            }
                            label={i18n.t("whatsappModal.form.default")}
                          />
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                            disabled={isSubmitting || tokenBusy}
                                color="primary"
                                id="connection-allowGroup"
                            name="allowGroup"
                                checked={values.allowGroup}
                              />
                            }
                            label={i18n.t("whatsappModal.form.group")}
                          />
                        </Grid>
                        <Grid xs={6} md={4} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel id="groupAsTicket-selection-label">{i18n.t("whatsappModal.form.groupAsTicket")}</InputLabel>
                            <Field
                              as={Select}
                            disabled={isSubmitting || tokenBusy}
                              label={i18n.t("whatsappModal.form.groupAsTicket")}
                              placeholder={i18n.t("whatsappModal.form.groupAsTicket")}
                              labelId="groupAsTicket-selection-label"
                              id="groupAsTicket"
                              name="groupAsTicket"
                            >
                              <MenuItem value={"disabled"}>{i18n.t("whatsappModal.menuItem.disabled")}</MenuItem>
                              <MenuItem value={"enabled"}>{i18n.t("whatsappModal.menuItem.enabled")}</MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                        <Grid xs={6} md={4} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel id="autoReply-selection-label">{i18n.t("whatsappModal.form.autoReply")}</InputLabel>
                            <Field
                              as={Select}
                            disabled={isSubmitting || tokenBusy}
                              label={i18n.t("whatsappModal.form.autoReply")}
                              placeholder={i18n.t("whatsappModal.form.autoReply")}
                              labelId="autoReply-selection-label"
                              id="autoReply"
                              name="autoReply"
                              value={values.autoReply || "enabled"}
                            >
                              <MenuItem value={"enabled"}>{i18n.t("whatsappModal.menuItem.enabled")}</MenuItem>
                              <MenuItem value={"disabled"}>{i18n.t("whatsappModal.menuItem.disabled")}</MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>


                    <div className={classes.importMessage}>
                      <div className={classes.multFieldLine}>
                        <FormControlLabel
                          style={{ marginRight: 7 }}
                          label={i18n.t("whatsappModal.form.importOldMessagesEnable")}
                          labelPlacement="end"
                          control={
                            <Switch
                              size="medium"
                              checked={enableImportMessage}
                              onChange={handleEnableImportMessage}
                              name="importOldMessagesEnable"
                              color="primary"
                            />
                          }
                        />

                        {enableImportMessage ? (
                          <>
                            <FormControlLabel
                              style={{ marginRight: 7 }}
                              label={i18n.t(
                                "whatsappModal.form.importOldMessagesGroups"
                              )}
                              labelPlacement="end"
                              control={
                                <Switch
                                  size="medium"
                                  checked={importOldMessagesGroups}
                                  onChange={(e) =>
                                    setImportOldMessagesGroups(e.target.checked)
                                  }
                                  name="importOldMessagesGroups"
                                  color="primary"
                                />
                              }
                            />

                            <FormControlLabel
                              style={{ marginRight: 7 }}
                              label={i18n.t(
                                "whatsappModal.form.closedTicketsPostImported"
                              )}
                              labelPlacement="end"
                              control={
                                <Switch
                                  size="medium"
                                  checked={closedTicketsPostImported}
                                  onChange={(e) =>
                                    setClosedTicketsPostImported(e.target.checked)
                                  }
                                  name="closedTicketsPostImported"
                                  color="primary"
                                />
                              }
                            />
                          </>) : <></>}
                      </div>

                      {enableImportMessage ? (
                        <Grid style={{ marginTop: 18 }} container spacing={1}>
                          <Grid item xs={6}>
                            <Field
                              fullWidth
                              as={TextField}
                            disabled={isSubmitting || tokenBusy}
                              label={i18n.t("whatsappModal.form.importOldMessages")}
                              type="datetime-local"
                              id="connection-importOldMessages"
                            name="importOldMessages"
                              inputProps={{
                                max: moment()
                                  .add(0, "minutes")
                                  .format("YYYY-MM-DDTHH:mm"),
                                min: moment()
                                  .add(-2, "years")
                                  .format("YYYY-MM-DDTHH:mm"),
                              }}
                              //min="2022-11-06T22:22:55"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.importOldMessages &&
                                Boolean(errors.importOldMessages)
                              }
                              helperText={
                                touched.importOldMessages && errors.importOldMessages
                              }
                              variant="outlined"
                              value={moment(importOldMessages).format(
                                "YYYY-MM-DDTHH:mm"
                              )}
                              onChange={(e) => {
                                setImportOldMessages(e.target.value);
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Field
                              fullWidth
                              as={TextField}
                            disabled={isSubmitting || tokenBusy}
                              label={i18n.t("whatsappModal.form.importRecentMessages")}
                              type="datetime-local"
                              id="connection-importRecentMessages"
                            name="importRecentMessages"
                              inputProps={{
                                max: moment()
                                  .add(0, "minutes")
                                  .format("YYYY-MM-DDTHH:mm"),
                                min: moment(importOldMessages).format(
                                  "YYYY-MM-DDTHH:mm"
                                )
                              }}
                              //min="2022-11-06T22:22:55"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.importRecentMessages &&
                                Boolean(errors.importRecentMessages)
                              }
                              helperText={
                                touched.importRecentMessages && errors.importRecentMessages
                              }
                              variant="outlined"
                              value={moment(importRecentMessages).format(
                                "YYYY-MM-DDTHH:mm"
                              )}
                              onChange={(e) => {
                                setImportRecentMessages(e.target.value);
                              }}
                            />
                          </Grid>
                          <Grid xs={12} md={12} xl={12} item>
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              className={classes.FormControl}
                              fullWidth
                            >
                              <InputLabel id="queueIdImportMessages-selection-label">
                                {i18n.t("whatsappModal.form.queueIdImportMessages")}
                              </InputLabel>
                              <Field
                                as={Select}
                            disabled={isSubmitting || tokenBusy}
                                name="queueIdImportMessages"
                                id="queueIdImportMessages"
                                value={values.queueIdImportMessages || '0'}
                                required={enableImportMessage}
                                label={i18n.t("whatsappModal.form.queueIdImportMessages")}
                                placeholder={i18n.t("whatsappModal.form.queueIdImportMessages")}
                                labelId="queueIdImportMessages-selection-label"
                              >
                                <MenuItem value={0}>&nbsp;</MenuItem>
                                {queues.map(queue => (
                                  <MenuItem key={queue.id} value={queue.id}>
                                    {queue.name}
                                  </MenuItem>
                                ))}
                              </Field>
                            </FormControl>
                          </Grid>
                        </Grid>

                      ) : null}
                    </div>
                    {enableImportMessage && (
                      <Typography className={classes.hint}>A importação será aplicada na próxima conexão por QR code. Salvar não desconecta a sessão atual.</Typography>
                    )}


                    {/* TOKEN */}
                    <Box display="flex" alignItems="center">
                      <Grid xs={6} md={12} item>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.token")}
                          type="password"
                          fullWidth
                          // name="token"
                          value={autoToken}
                          variant="outlined"
                          margin="dense"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Button
                        onClick={handleRefreshToken}
                        aria-label="Gerar novo token"
                        disabled={isSubmitting || tokenBusy}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={<Autorenew />}
                      />
                      <Button
                        onClick={handleCopyToken}
                        aria-label={copied ? "Token copiado" : "Copiar token"}
                        disabled={!autoToken || tokenBusy}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={<FileCopy color={copied ? "primary" : "inherit"} />}
                      />
                    </Box>
                    {confirmToken && <div className={classes.hint}>O token atual deixará de funcionar nas integrações externas. <Button size="small" onClick={handleRefreshToken}>Confirmar novo token</Button><Button size="small" onClick={() => setConfirmToken(false)}>Cancelar</Button></div>}

                    <div>
                      <h3>{i18n.t("whatsappModal.form.queueRedirection")}</h3>
                      <p>{i18n.t("whatsappModal.form.queueRedirectionDesc")}</p>
                      <Grid spacing={2} container>

                        <Grid xs={6} md={6} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel id="sendIdQueue-selection-label">
                              {i18n.t("whatsappModal.form.sendIdQueue")}
                            </InputLabel>
                            <Field
                              as={Select}
                            disabled={isSubmitting || tokenBusy}
                              name="sendIdQueue"
                              id="sendIdQueue"
                              value={values.sendIdQueue || '0'}
                              required={values.timeSendQueue > 0}
                              label={i18n.t("whatsappModal.form.sendIdQueue")}
                              placeholder={i18n.t("whatsappModal.form.sendIdQueue")}
                              labelId="sendIdQueue-selection-label"
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map(queue => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>

                        </Grid>

                        <Grid xs={6} md={6} item>
                          <Field
                            as={TextField}
                            disabled={isSubmitting || tokenBusy}
                            label={i18n.t("whatsappModal.form.timeSendQueue")}
                            fullWidth
                            id="connection-timeSendQueue"
                            name="timeSendQueue"
                            variant="outlined"
                            margin="dense"
                            error={touched.timeSendQueue && Boolean(errors.timeSendQueue)}
                            helperText={touched.timeSendQueue && errors.timeSendQueue}
                          />
                        </Grid>

                      </Grid>
                    </div>
                  </DialogContent>
                </TabPanel>
                {/* INTEGRAÇÃO */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"integrations"}
                >
                  <DialogContent dividers>
                    {/* FILAS */}
                    <FormControl fullWidth variant="outlined" margin="dense"><InputLabel id="connection-queues-label">Filas</InputLabel><Select labelId="connection-queues-label" label="Filas" multiple value={selectedQueueIds} disabled={isSubmitting || tokenBusy} onChange={event => handleChangeQueue(event.target.value)} renderValue={ids => ids.map(id => queues.find(queue => String(queue.id) === String(id))?.name || "Fila #" + id).join(", ")}>{queues.map(queue => <MenuItem key={queue.id} value={queue.id}>{queue.name}</MenuItem>)}</Select></FormControl>
                    {showIntegrations && (
                      <FormControl
                        variant="outlined"
                        margin="dense"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <InputLabel id="integrationId-selection-label">
                          {i18n.t("queueModal.form.integrationId")}
                        </InputLabel>
                        <Select
                          label={i18n.t("queueModal.form.integrationId")}
                          name="integrationId"
                          disabled={integrationsLoading || isSubmitting || tokenBusy}
                          value={selectedIntegration || ""}
                          onChange={handleChangeIntegration}
                          id="integrationId"
                          variant="outlined"
                          margin="dense"
                          placeholder={i18n.t("queueModal.form.integrationId")}
                          labelId="integrationId-selection-label"                        >
                          <MenuItem value="">Desabilitado</MenuItem>
                          {selectedIntegration && !integrations.some(item => String(item.id) === String(selectedIntegration)) && <MenuItem value={selectedIntegration}>{whatsApp.queueIntegrations?.name || "Integração #" + selectedIntegration}</MenuItem>}
                          {integrations.map((integration) => (
                            <MenuItem key={integration.id} value={integration.id}>
                              {integration.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {integrationsError && <FormHelperText error>Não foi possível carregar as integrações. <Button size="small" onClick={() => setIntegrationsRevision(value => value + 1)}>Tentar novamente</Button></FormHelperText>}
                      </FormControl>
                    )}
                    {showOpenAi && (
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        fullWidth
                      >
                        <InputLabel id="dialog-select-prompt-label">
                          {i18n.t("whatsappModal.form.prompt")}
                        </InputLabel>
                        <Select
                          labelId="dialog-select-prompt-label"
                          id="dialog-select-prompt"
                          disabled={promptsLoading || isSubmitting || tokenBusy}
                          name="promptId"
                          value={selectedPrompt || ""}
                          onChange={handleChangePrompt}
                          label={i18n.t("whatsappModal.form.prompt")}
                          fullWidth
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                        >
                          <MenuItem value="">Desabilitado</MenuItem>
                          {selectedPrompt && !prompts.some(prompt => Number(prompt.id) === Number(selectedPrompt)) && <MenuItem value={selectedPrompt}>{whatsApp.prompt?.name || `Assistente #${selectedPrompt}`}</MenuItem>}
                          {prompts.map((prompt) => (
                            <MenuItem
                              key={prompt.id}
                              value={prompt.id}
                            >
                              {prompt.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {promptsError && <Typography color="error" variant="caption" role="alert">Não foi possível carregar os assistentes. <Button size="small" onClick={() => setPromptsRevision(value => value + 1)}>Tentar novamente</Button></Typography>}
                      </FormControl>
                    )}
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"messages"}
                >
                  <DialogContent dividers>
                    <Typography component="h3">Mídia de saudação</Typography><Typography className={classes.hint}>Imagem ou vídeo de até 20 MB.</Typography>
                    {attachmentName && (
                      <div
                        style={{ display: 'flex', flexDirection: 'row-reverse' }}
                      >
                        <Button
                          variant='outlined'
                          color="primary"
                          endIcon={<DeleteOutlineIcon />}
                          onClick={handleDeleFile}
                        >
                          {attachmentName}
                        </Button>
                      </div>
                    )}
                    <div
                      style={{ display: 'flex', flexDirection: "column-reverse" }}
                    >
                      <input
                        type="file"
                        accept="video/*,image/*"
                        ref={inputFileRef}
                        style={{ display: 'none' }}
                        onChange={handleFileUpload}
                      />
                      <Button variant="outlined" color="primary" onClick={() => inputFileRef.current.click()}>
                        Adicionar imagem ou vídeo de saudação
                      </Button>
                    </div>

                    {/* MENSAGEM DE SAUDAÇÃO */}
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.greetingMessage")}
                          type="greetingMessage"
                          multiline
                          rows={4}
                          fullWidth
                          id="connection-greetingMessage"
                            name="greetingMessage"
                          error={
                            touched.greetingMessage && Boolean(errors.greetingMessage)
                          }
                          helperText={
                            touched.greetingMessage && errors.greetingMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>

                      {/* MENSAGEM DE CONCLUSÃO */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.complationMessage")}
                          multiline
                          rows={4}
                          fullWidth
                          id="connection-complationMessage"
                            name="complationMessage"
                          error={
                            touched.complationMessage &&
                            Boolean(errors.complationMessage)
                          }
                          helperText={
                            touched.complationMessage && errors.complationMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>

                      {/* MENSAGEM DE FORA DE EXPEDIENTE */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.outOfHoursMessage")}
                          multiline
                          rows={4}
                          fullWidth
                          id="connection-outOfHoursMessage"
                            name="outOfHoursMessage"
                          error={touched.outOfHoursMessage && Boolean(errors.outOfHoursMessage)}
                          helperText={touched.outOfHoursMessage && errors.outOfHoursMessage}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      {/* MENSAGEM DE FÉRIAS COLETIVAS */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.collectiveVacationMessage")}
                          multiline
                          rows={4}
                          fullWidth
                          id="connection-collectiveVacationMessage"
                            name="collectiveVacationMessage"
                          error={touched.collectiveVacationMessage && Boolean(errors.collectiveVacationMessage)}
                          helperText={touched.collectiveVacationMessage && errors.collectiveVacationMessage}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          fullWidth
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.collectiveVacationStart")}
                          type="date"
                          id="connection-collectiveVacationStart"
                            name="collectiveVacationStart"
                          required={values.collectiveVacationMessage?.length > 0}
                          inputProps={{
                            min: moment()
                              .add(-10, "days")
                              .format("YYYY-MM-DD"),
                          }}
                          //min="2022-11-06T22:22:55"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={
                            touched.collectiveVacationStart &&
                            Boolean(errors.collectiveVacationStart)
                          }
                          helperText={
                            touched.collectiveVacationStart && errors.collectiveVacationStart
                          }
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          fullWidth
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.collectiveVacationEnd")}
                          type="date"
                          id="connection-collectiveVacationEnd"
                            name="collectiveVacationEnd"
                          required={values.collectiveVacationMessage?.length > 0}
                          inputProps={{
                            min: moment()
                              .add(-10, "days")
                              .format("YYYY-MM-DD")
                          }}
                          //min="2022-11-06T22:22:55"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={
                            touched.collectiveVacationEnd &&
                            Boolean(errors.collectiveVacationEnd)
                          }
                          helperText={
                            touched.collectiveVacationEnd && errors.collectiveVacationEnd
                          }
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                </TabPanel>

                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"chatbot"}
                >
                  <DialogContent dividers>
                    <Grid spacing={2} container>
                      {/* TEMPO PARA CRIAR NOVO TICKET */}
                      <Grid xs={6} md={4} item>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.timeCreateNewTicket")}
                          fullWidth
                          id="connection-timeCreateNewTicket"
                            name="timeCreateNewTicket"
                          variant="outlined"
                          margin="dense"
                          error={touched.timeCreateNewTicket && Boolean(errors.timeCreateNewTicket)}
                          helperText={touched.timeCreateNewTicket && errors.timeCreateNewTicket}
                        />
                      </Grid>

                      {/* QUANTIDADE MÁXIMA DE VEZES QUE O CHATBOT VAI SER ENVIADO */}
                      <Grid xs={6} md={4} item>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.maxUseBotQueues")}
                          fullWidth
                          id="connection-maxUseBotQueues"
                            name="maxUseBotQueues"
                          variant="outlined"
                          margin="dense"
                          error={touched.maxUseBotQueues && Boolean(errors.maxUseBotQueues)}
                          helperText={touched.maxUseBotQueues && errors.maxUseBotQueues}
                        />
                      </Grid>
                      {/* TEMPO PARA ENVIO DO CHATBOT */}
                      <Grid xs={6} md={4} item>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.timeUseBotQueues")}
                          fullWidth
                          id="connection-timeUseBotQueues"
                            name="timeUseBotQueues"
                          variant="outlined"
                          margin="dense"
                          error={touched.timeUseBotQueues && Boolean(errors.timeUseBotQueues)}
                          helperText={touched.timeUseBotQueues && errors.timeUseBotQueues}
                        />
                      </Grid>
                    </Grid>
                    <Grid spacing={2} container>
                      {/* ENCERRAR CHATS ABERTOS APÓS X HORAS */}
                      <Grid xs={6} md={6} item>
                        <Field
                          as={TextField}
                            disabled={isSubmitting || tokenBusy}
                          label={i18n.t("whatsappModal.form.expiresTicket")}
                          fullWidth
                          id="connection-expiresTicket"
                            name="expiresTicket"
                          required={values.timeInactiveMessage > 0}
                          variant="outlined"
                          margin="dense"
                          error={touched.expiresTicket && Boolean(errors.expiresTicket)}
                          helperText={touched.expiresTicket && errors.expiresTicket}
                        />
                      </Grid>
                      {/* TEMPO PARA ENVIO DO CHATBOT */}
                      <Grid xs={6} md={6} item>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          className={classes.formControl}
                        >
                          <InputLabel id="whenExpiresTicket-selection-label">
                            {i18n.t("whatsappModal.form.whenExpiresTicket")}
                          </InputLabel>
                          <Field
                            as={Select}
                            disabled={isSubmitting || tokenBusy}
                            label={i18n.t("whatsappModal.form.whenExpiresTicket")}
                            placeholder={i18n.t(
                              "whatsappModal.form.whenExpiresTicket"
                            )}
                            labelId="whenExpiresTicket-selection-label"
                            id="whenExpiresTicket"
                            name="whenExpiresTicket"
                          >
                            <MenuItem value={"0"}>{i18n.t("whatsappModal.form.closeLastMessageOptions1")}</MenuItem>
                            <MenuItem value={"1"}>{i18n.t("whatsappModal.form.closeLastMessageOptions2")}</MenuItem>
                          </Field>
                        </FormControl>
                      </Grid>
                    </Grid>
                    {/* MENSAGEM POR INATIVIDADE*/}
                    <div>
                      <Field
                        as={TextField}
                            disabled={isSubmitting || tokenBusy}
                        label={i18n.t("whatsappModal.form.expiresInactiveMessage")}
                        multiline
                        rows={4}
                        fullWidth
                        id="connection-expiresInactiveMessage"
                            name="expiresInactiveMessage"
                        error={touched.expiresInactiveMessage && Boolean(errors.expiresInactiveMessage)}
                        helperText={touched.expiresInactiveMessage && errors.expiresInactiveMessage}
                        variant="outlined"
                        margin="dense"
                      />
                    </div>

                    {/* TEMPO PARA ENVIO DE MENSAGEM POR INATIVIDADE */}
                    <Field
                      as={TextField}
                            disabled={isSubmitting || tokenBusy}
                      label={i18n.t("whatsappModal.form.timeInactiveMessage")}
                      fullWidth
                      id="connection-timeInactiveMessage"
                            name="timeInactiveMessage"
                      variant="outlined"
                      margin="dense"
                      error={touched.timeInactiveMessage && Boolean(errors.timeInactiveMessage)}
                      helperText={touched.timeInactiveMessage && errors.timeInactiveMessage}
                    />
                    {/* MENSAGEM POR INATIVIDADE*/}
                    <div>
                      <Field
                        as={TextField}
                            disabled={isSubmitting || tokenBusy}
                        label={i18n.t("whatsappModal.form.inactiveMessage")}
                        multiline
                        rows={4}
                        fullWidth
                        id="connection-inactiveMessage"
                            name="inactiveMessage"
                        error={touched.inactiveMessage && Boolean(errors.inactiveMessage)}
                        helperText={touched.inactiveMessage && errors.inactiveMessage}
                        variant="outlined"
                        margin="dense"
                      />
                    </div>
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"nps"}
                >
                  <DialogContent dividers>
                    {/* MENSAGEM DE AVALIAÇAO*/}
                    <div>
                      <Field
                        as={TextField}
                            disabled={isSubmitting || tokenBusy}
                        label={i18n.t("whatsappModal.form.ratingMessage")}
                        multiline
                        rows={4}
                        fullWidth
                        id="connection-ratingMessage"
                            name="ratingMessage"
                        error={touched.ratingMessage && Boolean(errors.ratingMessage)}
                        helperText={touched.ratingMessage && errors.ratingMessage}
                        variant="outlined"
                        margin="dense"
                      />
                    </div>
                    {/* QUANTIDADE MÁXIMA DE VEZES QUE O NPS VAI SER ENVIADO */}
                    <div>
                      <Field
                        as={TextField}
                            disabled={isSubmitting || tokenBusy}
                        label={i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
                        fullWidth
                        id="connection-maxUseBotQueuesNPS"
                            name="maxUseBotQueuesNPS"
                        variant="outlined"
                        margin="dense"
                        error={touched.maxUseBotQueuesNPS && Boolean(errors.maxUseBotQueuesNPS)}
                        helperText={touched.maxUseBotQueuesNPS && errors.maxUseBotQueuesNPS}
                      />
                    </div>
                    {/* ENCERRAR CHATS NPS APÓS X Minutos */}
                    <div>
                      <Field
                        as={TextField}
                            disabled={isSubmitting || tokenBusy}
                        label={i18n.t("whatsappModal.form.expiresTicketNPS")}
                        fullWidth
                        id="connection-expiresTicketNPS"
                            name="expiresTicketNPS"
                        variant="outlined"
                        margin="dense"
                        error={touched.expiresTicketNPS && Boolean(errors.expiresTicketNPS)}
                        helperText={touched.expiresTicketNPS && errors.expiresTicketNPS}
                      />
                    </div>
                  </DialogContent>
                </TabPanel>
                {/* Flowbuilder */}
                {showIntegrations && (
                  <>
                    <TabPanel
                      className={classes.container}
                      value={tab}
                      name={"flowbuilder"}
                    >
                      <DialogContent>
                        <h3 id="flowIdWelcome-selection-label">Fluxo de boas-vindas</h3>
                        <p>Este fluxo é disparado apenas para novos contatos, pessoas que voce não possui em sua lista de contatos e que mandaram uma mensagem
                        </p>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.FormControl}
                          fullWidth
                        >
                          <Select
                            name="flowIdWelcome"
                            disabled={isSubmitting || tokenBusy}
                            value={flowIdWelcome || ""}
                            onChange={handleChangeFlowIdWelcome}
                            id="flowIdWelcome"
                            variant="outlined"
                            margin="dense"
                            labelId="flowIdWelcome-selection-label"                        >
                            <MenuItem value="">Desabilitado</MenuItem>
                            {flowIdWelcome && !webhooks.some(item => String(item.id) === String(flowIdWelcome)) && <MenuItem value={flowIdWelcome}>Fluxo #{flowIdWelcome}</MenuItem>}
                            {webhooks.map(webhook => (
                              <MenuItem key={webhook.id} value={webhook.id}>
                                {webhook.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </DialogContent>
                      <DialogContent>
                        <h3 id="flowNotIdPhrase-selection-label">Fluxo de resposta padrão</h3>
                        <p>Resposta Padrão é enviada com qualquer caractere diferente de uma palavra chave. ATENÇÃO! Será disparada se o atendimento ja estiver fechado.

                        </p>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.FormControl}
                          fullWidth
                        >
                          <Select
                            name="flowNotIdPhrase"
                            disabled={isSubmitting || tokenBusy}
                            value={flowIdNotPhrase || ""}
                            onChange={handleChangeFlowIdNotPhrase}
                            id="flowNotIdPhrase"
                            variant="outlined"
                            margin="dense"
                            labelId="flowNotIdPhrase-selection-label"                        >
                            <MenuItem value="">Desabilitado</MenuItem>
                            {flowIdNotPhrase && !webhooks.some(item => String(item.id) === String(flowIdNotPhrase)) && <MenuItem value={flowIdNotPhrase}>Fluxo #{flowIdNotPhrase}</MenuItem>}
                            {webhooks.map(webhook => (
                              <MenuItem key={webhook.id} value={webhook.id}>
                                {webhook.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </DialogContent>
                    </TabPanel>
                  </>
                )}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"schedules"}
                >
                  <DialogContent><Typography component="h3">Horários de atendimento</Typography>
                    {schedules.map((day, index) => <section key={day.weekdayEn} className={classes.day}><span>{day.weekday}</span>{[["startTimeA", "Início 1"], ["endTimeA", "Fim 1"], ["startTimeB", "Início 2"], ["endTimeB", "Fim 2"]].map(([key, label]) => <TextField key={key} label={label} type="time" size="small" variant="outlined" value={day[key] || ""} InputLabelProps={{ shrink: true }} inputProps={{ "aria-label": day.weekday + ": " + label, step: 60 }} onChange={event => { const value = event.target.value; setSchedules(items => items.map((item, i) => i === index ? { ...item, [key]: value } : item)); }} />)}</section>)}
                    <Typography className={classes.hint}>Dia sem atendimento: deixe os quatro horários vazios.</Typography>
                  </DialogContent>
                </TabPanel>
              </fieldset></Paper>
              <DialogActions className={classes.footer}>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting || tokenBusy}
                  variant="outlined"
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting || tokenBusy}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {isSubmitting ? "Salvando…" : persistedId.current ? "Salvar" : "Adicionar"}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>}
      </Dialog>
    </div>
  );
};

export default function WhatsAppModal({ open, ...props }) { return open ? <ContactsTheme><WhatsAppEditor key={props.whatsAppId || "new"} open {...props} /></ContactsTheme> : null; }
